import React from 'react';
import {
  BrowserRouter,
  Route,
  Switch,
} from 'react-router-dom';
import {
  ThemeProvider,
} from 'styled-components';
import {
  Web3ReactProvider,
} from '@web3-react/core';
import {
  providers,
} from 'ethers';

import lightTheme from '../../style/lightTheme';
import GlobalStyle from '../../style/globalStyle';

import Header from '../header';
import Footer from '../footer';

import Home from '../../routes/home';

function getLibrary(provider: any): providers.Web3Provider | providers.JsonRpcProvider {
  if (provider.host !== undefined) {
    const library = new providers.JsonRpcProvider(provider, 'any');
    library.pollingInterval = 15000;
    return library;
  }

  const library = new providers.Web3Provider(provider, 'any');
  library.pollingInterval = 15000;
  return library;
}

function App() {
  return (
    <BrowserRouter>
      <>
        <ThemeProvider theme={lightTheme}>
          <>
            <Web3ReactProvider getLibrary={getLibrary}>
              <GlobalStyle />
              <Header />
              <Switch>
                <Route path="/" component={Home} />
              </Switch>
              <Footer />
            </Web3ReactProvider>
          </>
        </ThemeProvider>
      </>
    </BrowserRouter>
  );
}

export default App;
